import React from 'react';

const WeightMenu=() => {
    return (
        <div>
            <h1>
                Weight(lbs):
            </h1>
            <form>
                <input type = "text" id="weight" placeholder="Any"></input>
            </form>
        </div>

    )
}

export default WeightMenu